module.exports = __webpack_public_path__ + "static/img/dialog-bg.2ab1a2a0.png";